export default __webpack_public_path__ + "static/media/7.0db118a3.webp";